import React, {useEffect, useState, useMemo} from "react";
import Styles from "./SubscriptionList.module.scss"
import {useAppDispatch} from "../../../../redux/store";
import {fetchHistory} from "../../../../redux/profile/history/asyncActions";
import {useSelector} from "react-redux";
import {getUserHistory} from "../../../../redux/profile/history/selectors";
import preloader from "../../../../assets/img/load.gif";
import SubscriptionItem from "../SubscriptionsItem/SubscriptionItem";
import HallsItem from "../HallsItem/HallsItem";
import {IItem} from "../../../../redux/profile/history/types";
import { getProfileInfoMenu } from "../../../../redux/profile/profileInfo/selectors";
import { partnerIdSelector, userDataSelector } from "../../../../redux/user/selectors";
import { subscriptionsSelector } from "../../../../redux/subscriptions/selectors";

const SubscriptionList: React.FC = (props) => {

    const dispatch = useAppDispatch();
    const {items, isLoading} = useSelector(getUserHistory)
    const { myProfiles } = useSelector(getProfileInfoMenu);
    const userPartnerId = useSelector(partnerIdSelector);
    const userData = useSelector(userDataSelector);
    const { subscriptions } = useSelector(subscriptionsSelector);
    const [activeSubscriptions, setActiveSubscriptions] = useState<IItem[]>([])
    const [upcomingRents, setUpcomingRents] = useState<any[]>([])

    useEffect(() => {
        dispatch(fetchHistory())
    },[])

    const adaptSubscriptionData = (item: IItem): IItem => {
        const itemPartnerId = (item as any).partnerId || (item as any).partner_id;
        let ownerName = item.profile?.name || "Пользователь";
        
        if (itemPartnerId) {
            if (userPartnerId && String(userPartnerId) === String(itemPartnerId)) {
                if (userData?.name) {
                    ownerName = userData.name;
                }
            } else if (myProfiles && myProfiles.length > 0) {
                const matchingProfile = myProfiles.find((profile: any) => {
                    const profilePartnerId = profile.partner_id;
                    if (!profilePartnerId) return false;
                    return String(profilePartnerId) === String(itemPartnerId);
                });
                
                if (matchingProfile) {
                    ownerName = matchingProfile.name;
                }
            }
        }
        
        return {
            ...item,
            profile: {
                ...item.profile,
                name: ownerName
            }
        };
    };

    useEffect(() => {
        if (items && items.length > 0) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            const active = items.filter((item) => {
                if (item.subscription) {
                    const finishDate = new Date(item.date_to_iso || item.expires_at);
                    return finishDate >= today;
                }
                return false;
            });
            
            const adaptedActive = active.map(item => adaptSubscriptionData(item));
            
            setActiveSubscriptions(adaptedActive);
        }
    }, [items, myProfiles, userPartnerId])

    return(
        <div className={Styles.wrapper}>
            {
                isLoading ? (
                    <div className={Styles.preloader}>
                        <img className={Styles.preloader_img} src={preloader} alt="preloader" />
                    </div>
                ) : (
                    <>
                        {activeSubscriptions.length > 0 && (
                            <div className={Styles.section}>
                                <h3 className={Styles.sectionTitle}>Активные абонементы</h3>
                                <div className={Styles.item}>
                                    {activeSubscriptions.map((item, index) => {
                                        return <SubscriptionItem key={item.id || `subscription-${index}`} status="big" data={item} subscriptions={subscriptions}/>
                                    })}
                                </div>
                            </div>
                        )}
                        
                        {upcomingRents.length > 0 && (
                            <div className={Styles.section}>
                                <h3 className={Styles.sectionTitle}>Предстоящие аренды</h3>
                                <div className={Styles.item}>
                                    {upcomingRents.map((rent) => (
                                        <HallsItem key={rent.id} data={rent} />
                                    ))}
                                </div>
                            </div>
                        )}
                        
                        {activeSubscriptions.length === 0 && upcomingRents.length === 0 && (
                            <div className={Styles.emptyState}>
                                <p>У вас нет активных абонементов и предстоящих аренд</p>
                            </div>
                        )}
                    </>
                )
            }
        </div>
    )

}

export default SubscriptionList
